import $ from 'jquery';
import Lights from 'shared/components/lights';
import { showNavbar, hideNavbar, removeBodyScroll, restoreBodyScroll } from './ReportIssueUtils';
import ReportEnvironment from './ReportEnvironment';
import Snackbar from 'components/shared/Snackbar/Snackbar';
import { ActiveLanguage } from 'shared/vidio_helpers';
import PollyAdapter from 'components/shared/PollyAdapter';

export default class ReportPlayerIssue {
  constructor({$element: $element}){
    this.$element = $element;
    this.lights = Lights;

    this.selector = {
      formContainer: '.report-abuse-scrollable-container',
      form: '#report-abuse-player-issues',
      submitButton: ".report-abuse__submit-button--player-issues",
      cancelButton: ".report-abuse__cancel-button--player-issues",
      fieldIssueCategory: "#report-abuse-player__issue-category",
      fieldIssueCategoryCode: "#report-abuse-player__issue-category-code",
      fieldIssueDetail: "#report-abuse-player__issue-detail",
      fieldPlatform: "#report-abuse-player__platform",
      fieldDeviceModel: "#report-abuse-player__device-model",
      fieldIsSupportDrm: "#report-abuse-player__is-support-drm",
      fieldAppVersion: "#report-abuse-player__app-version",
      fieldDeviceId: "#report-abuse-player__device-id",
      radioContainer: "#report-abuse-player-issues .report-abuse__radio-container",
      fieldHarFile: '#report-abuse-player__har-file'
    }

    this.ui = {};

    Object.keys(this.selector).forEach((key) => {
      this.ui[key] = $(this.selector[key]);
    });
  }

  init() {
    this.bindFormSubmitClick();
    this.bindFormCancelClick();
    this.bindFormSubmitted();
    this.bindFormClick();
    this.bindFormContainerClick();
  }

  bindFormSubmitClick(){
    this.ui.submitButton.on('click', this.hideForm.bind(this));
  }

  bindFormCancelClick(){
    this.ui.cancelButton.on('click', this.hideForm.bind(this));
  }

  bindFormSubmitted(){
    this.ui.form.on('ajax:success', this.onFormSubmitted.bind(this));
  }

  onFormSubmitted(){
      this.resetForm();
      this.showSubmittedNotification();
  }

  showForm() {
    this.getIssuesList();
    this.assignAdditionalData();

    removeBodyScroll();
    this.ui.formContainer.show();
    this.lights.off.bind(this)();
    hideNavbar();
  }

  hideForm() {
    restoreBodyScroll();
    this.ui.formContainer.hide();
    this.lights.on.bind(this)();
    showNavbar();
  }

  close(){
    this.hideForm();
  }

  assignAdditionalData() {
    this.ui.fieldPlatform.val(ReportEnvironment.platform());
    this.ui.fieldDeviceModel.val(ReportEnvironment.deviceModel());
    this.ui.fieldAppVersion.val(ReportEnvironment.appVersion());
    this.ui.fieldDeviceId.val(ReportEnvironment.deviceId());
    this.fillHarField();
  }

  async fillHarField() {
    await PollyAdapter.stop();
    const har = PollyAdapter.har();
    const stringify_har = JSON.stringify(har);
    this.ui.fieldHarFile.val(stringify_har);
  }

  getIssuesList() {
    if(this.issueAttributes) return;

    $.get(this.issuesPath()).done((data) => {
      const attributes = data.data[0].attributes;
      this.ui.fieldIssueCategory.val(attributes.issue_category)
      this.ui.fieldIssueCategoryCode.val(attributes.issue_category_code)

      attributes.issue_list.forEach((issue) => {
        this.appendPlayerIssues(issue.issue_detail, issue.issue_code);
      })

      this.issueAttributes = attributes;
    });
  }

  appendPlayerIssues(issueDetail, issueDetailCode){
    let element = this.createIssueItemElement(issueDetail, issueDetailCode);
    this.bindClickToIssueElement(element, issueDetail);
    this.ui.radioContainer.append(element);
  }

  createIssueItemElement(issueDetail, issueDetailCode){
    let element = document.createElement('div');
    element.classList.add('report-abuse__radio');
    element.innerHTML = `
      <label for="issue_detail_code_${issueDetailCode}">
        <input id="issue_detail_code_${issueDetailCode}" type="radio" name="issue_detail_code" value="${issueDetailCode}">
        <span>${issueDetail}</span>
      </label>
    `;
    return element
  }

  bindClickToIssueElement(element, issueDetail){
    $(element).on('click', this.changeIssueDetailOnClick.bind(this, issueDetail));
  }

  changeIssueDetailOnClick(issueDetail){
    this.ui.fieldIssueDetail.val(issueDetail);
    this.ui.submitButton.attr('disabled', false);
  }

  issuesPath(){
    return this.ui.form.attr('action');
  }

  resetForm(){
    this.ui.form.trigger('reset');
    this.ui.submitButton.attr('disabled', true);
  }

  showSubmittedNotification(){
    let lang = ActiveLanguage.get();
    Snackbar.create({text: window.Locale[lang].watch.issues.success_notification});
  }

  bindFormClick() {
    this.ui.form.on('click', (e) => {
      e.stopPropagation();
    });
  }

  bindFormContainerClick() {
    this.ui.formContainer.on('click', () => {
      this.hideForm();
    });
  }
}
